import React from "react";
import Sidebar from "../../../components/sidebar";
import Header from "../../../components/header";
import { useRef, useState } from "react";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap";
import API_BASE_URL from "../../../config";
import DoctorTable from "../../../components/admin/master/doctorTable";
import { authFetch } from "../../../utility/authFetch";

function Doctor() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(false);
  const [reload, setReload] = useState(0);
  const [doctor, setDoctor] = useState("");
  const [fees, setFees] = useState("");
  const [category, setCategory] = useState("");
  const [nextPayday, setNextPayday] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [onlineLimit, setOnlineLimit] = useState("");
  const [offlineLimit, setOfflineLimit] = useState("");

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    setIsSubmitting(true);

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      setIsSubmitting(false);
      setLoader(false);
      return;
    }

    const formData = new FormData(formRef.current);
    const url = editMode
      ? `${API_BASE_URL}/api/edit-doctor-master`
      : `${API_BASE_URL}/api/doctor-master`;

    if (editMode) {
      formData.append("ID", editId);
    }

    const method = editMode ? "PUT" : "POST";

    try {
      const response = await authFetch(url, {
        method,
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert(
          editMode ? "Doctor updated successfully" : "Doctor added successfully"
        );
        formRef.current.reset();
        setIsSubmitting(false);
        setDoctor("");
        setFees("");
        setNextPayday("");
        setCategory("");
        setOnlineLimit("");
        setOfflineLimit("");
        setEditMode(false);
        setLoader(false);
        setEditId(null);
        setReload((prev) => prev + 1);
      } else {
        alert(result.error || "Error uploading data");
        setIsSubmitting(false);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  const handleEdit = (item) => {
    setDoctor(item.name);
    setFees(item.fees);
    setNextPayday(item.nextPayDay);
    setCategory(item.category);
    setEditMode(true);
    setEditId(item.id);
    setOnlineLimit(item.onlineLimit);
    setOfflineLimit(item.offlineLimit);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container bg-white p-4 rounded shadow-sm">
            <h5 className="mb-3">Doctor Master</h5>
            <Form onSubmit={handleSubmit} ref={formRef}>
              <Row className="align-items-end g-3">
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formDoctorName">
                    <Form.Label>
                      Doctor Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Doctor Name"
                      name="name"
                      value={doctor}
                      onChange={(e) => setDoctor(e.target.value)}
                      required
                      autoComplete="off"
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formCategory">
                    <Form.Label>
                      Category <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      aria-label="Category"
                      name="category"
                      required
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                    >
                      <option value="Orthopedic">Orthopedic</option>
                      <option value="Gynecology">Gynecology</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formFees">
                    <Form.Label>
                      Fees <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Enter Fees"
                      name="fees"
                      value={fees}
                      onChange={(e) => setFees(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formNextPayday">
                    <Form.Label>
                      Next Payday <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Enter Next Payday"
                      name="nextPayDay"
                      value={nextPayday}
                      onChange={(e) => setNextPayday(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formNextPayday">
                    <Form.Label>
                      Offline Limit <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Enter Offline Limit"
                      name="offlineLimit"
                      value={offlineLimit}
                      onChange={(e) => setOfflineLimit(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formNextPayday">
                    <Form.Label>
                      Online Limit <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Enter Online Limit"
                      name="onlineLimit"
                      value={onlineLimit}
                      onChange={(e) => setOnlineLimit(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Button variant="primary" type="submit" disabled={isSubmitting}>
                {editMode ? "UPDATE" : "SUBMIT"}
              </Button>
            </Form>
          </div>

          <div className="container bg-white p-4 rounded shadow-sm mt-4">
            <h5 className="mb-3">Doctor List</h5>
            <DoctorTable onEdit={handleEdit} reload={reload} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Doctor;
